export interface Role {
  id: number;
  roleCode: string;
  roleName: string;
  description: string;
}
